import CryptoJS from 'crypto-js';

export const decryptAesEcbBase64 = (cipherB64: string, key: string): string => {
    if (!key || key.length !== 16) throw new Error('HTML encryption key must be 16 characters (128-bit).');
    const decrypted = CryptoJS.AES.decrypt(cipherB64, CryptoJS.enc.Utf8.parse(key), {
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.ECB,
    });
    if (decrypted.sigBytes === 0) throw new Error('Failed to decrypt payload. Check key/mode.');
    return decrypted.toString(CryptoJS.enc.Utf8);
};
